module.exports = __webpack_public_path__ + "img/Mulia-on-board.c2040ac6.jpg";